import { render } from "./modalRelationCompany.vue?vue&type=template&id=367e84ec&scoped=true&ts=true"
import script from "./modalRelationCompany.vue?vue&type=script&lang=ts"
export * from "./modalRelationCompany.vue?vue&type=script&lang=ts"

import "./modalRelationCompany.vue?vue&type=style&index=0&id=367e84ec&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367e84ec"]])

export default __exports__